import { Box, useMediaQuery, Typography, type Theme } from '@mui/material';
import { SEOSegmentationPageType } from '@/__generated__/globalTypes';
import { getSearchResults_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_archivedJobSearchResults as SEOSegmentationArchivedJobSearchResult } from '@/__generated__/getSearchResults';
import { SEARCH_RESULT_TYPE } from '@/constants';
import ArchivedJobSearchResult from '@/components/SearchResults/ArchivedJobSearchResult';
import SeoConversionBox from '@/components/SeoConversionBox';

interface ArchivedJobSearchResultsProps {
  city: string | null;
  conversionHeader?: string | null;
  enrollmentURL?: string;
  pageType: SEOSegmentationPageType;
  results: SEOSegmentationArchivedJobSearchResult[];
  resultType: keyof typeof SEARCH_RESULT_TYPE;
}

const ArchivedJobSearchResults = ({
  city,
  conversionHeader = null,
  enrollmentURL,
  pageType,
  results,
  resultType,
}: ArchivedJobSearchResultsProps) => {
  const isMobileOrSmaller = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));

  const targetValue = isMobileOrSmaller ? '' : '_blank';
  return (
    <>
      <Box data-testid="SeoConversionCTAs" my={4} mx={-2} bgcolor="grey.100">
        <SeoConversionBox
          pageType={pageType}
          resultType={resultType}
          header={conversionHeader}
          enrollmentURL={enrollmentURL}
        />
      </Box>
      <Box mt={{ xs: 0, sm: 6 }} mb={1}>
        <Typography align="left" variant="h2" fontWeight="400">
          Previous Jobs in {city}
        </Typography>
      </Box>
      <Box mb={5}>
        <Typography align="left" variant="body1">
          See some jobs that were posted or filled recently.
        </Typography>
      </Box>
      {results.map((searchResult: SEOSegmentationArchivedJobSearchResult, idx) => {
        return (
          <Box key={`${searchResult.seoSegmentationArchivedJob.type}-${idx + 1}`}>
            <Box mb={5}>
              {/* eslint-disable react/jsx-no-target-blank */}
              <a
                href={enrollmentURL}
                target={targetValue}
                aria-label="profile-link"
                style={{ textDecoration: 'none' }}>
                <ArchivedJobSearchResult job={searchResult.seoSegmentationArchivedJob} />
              </a>
            </Box>
          </Box>
        );
      })}
    </>
  );
};

export default ArchivedJobSearchResults;
